import { createAsyncThunk } from "@reduxjs/toolkit";
import { JobsResponse } from "api/models/queues";
import { queuesService } from "api/services";

export const stuckJobsActions = {
    getSummary: "stuckJobs/getSummary"
};

export const getStuckJobsSummary = createAsyncThunk(
    stuckJobsActions.getSummary,
    async () => {
        // Query jobs with status=3 (Stuck) across all brand families
        const response = await queuesService.getJobs({
            status: 3,
            page: 0,
            take: 1 // We only need the count, not the actual jobs
        }) || {} as JobsResponse;

        return {
            hasStuckJobs: response.totalCount > 0,
            stuckCount: response.totalCount
        };
    }
);

